export var CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export var CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export var CREATE_USER_ERROR = 'CREATE_USER_ERROR';
export var RESET_USER_REQUEST = 'RESET_USER_REQUEST';
export var LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export var LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export var LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export var FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export var FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export var FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export var FETCH_USER_UNAUTHORIZED = 'FETCH_USER_UNAUTHORIZED';
export var UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST = 'UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST';
export var UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export var UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export var UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export var UPDATE_USER_PASSWORD_REQUEST = 'UPDATE_USER_PASSWORD_REQUEST';
export var UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS';
export var UPDATE_USER_PASSWORD_ERROR = 'UPDATE_USER_PASSWORD_ERROR';
